export default "__VITE_ASSET__BpVjQhBI__"